import { useLayoutEffect, useRef } from "react";
import type { RowData } from "@tanstack/react-table";
import { isEqual } from "@common/helpers/comparison";
import type { DataGridReactTable } from "../../types";
import { collapseRange } from "./rangeActions";

/**
 * A sort, column reorder, pin, or grouping change collapses the range to the
 * active cell: the cells it covered are no longer one rectangle. Values are
 * compared, so a controlled slice rebuilt each render keeps the range.
 */
export const useRangeReset = <TData extends RowData>(
    table: DataGridReactTable<TData>,
) => {
    const { sorting, columnOrder, columnPinning, grouping } = table.state;
    const layoutRef = useRef({ sorting, columnOrder, columnPinning, grouping });

    useLayoutEffect(() => {
        const layout = { sorting, columnOrder, columnPinning, grouping };
        if (!isEqual(layout, layoutRef.current)) {
            layoutRef.current = layout;
            collapseRange(table);
        }
    }, [table, sorting, columnOrder, columnPinning, grouping]);
};
